// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v5-list__finished,.v5-list__loading{text-align:center}.v5-list__finished-text,.v5-list__loading-text{display:inline-block;vertical-align:middle;font-size:.346667rem;color:#999;line-height:1.333333rem}", ""]);
// Exports
module.exports = exports;
